import React from 'react';
import '../css/OkasBoxes.css';
import '../css/SubscriptionPlan.css';
import Icon from 'react-icons-kit';
import { iosPlusEmpty } from 'react-icons-kit/ionicons';
import AddIcon from '@mui/icons-material/Add';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
// import OkasBoxesView from './OkasBoxesView';
import SubscriptionView from './SubscriptionView';
import SubscriptionPlanView from './SubscriptionPlanView';
import SubscriptionPlanEdit from './SubscriptionPlanEdit';
import OkasBoxesEdit from './OkasBoxesEdit';
import OkasBoxesAddNew from './OkasBoxesAddNew';
import Sorting from './Sorting';
// import SearchBar from 'material-ui-search-bar';
import SearchBar from './SearchBar';
// import SearchBarNew from './SearchBar'; 
import * as ActionTypes from '../actions/types';
import { connect } from 'react-redux';
import { Tooltip, OverlayTrigger, Overlay } from 'react-bootstrap'
import { calculator } from 'react-icons-kit/ionicons';
// import { Hidden, TablePagination } from '@material-ui/core';
import edit from './../assets/images/edit.svg';
import view from './../assets/images/view.svg';
import deleteIcon from './../assets/images/delete.svg';
import Pagination from 'react-bootstrap/Pagination'
import SubscriptionsAddPlans from './SubscriptionsAddPlans';

import Loader from './Loader';
import { IconButton } from '@mui/material';

//Subscriptions plans dashboard page
const customStylesDelete = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    minHeight: '40%',
    overflow: 'auto',
    padding: '2%',
    backgroundColor: '#EFF3F6'
  }
};

const styles = theme => ({
  root: {
    display: 'flex',
    // flexWrap: 'wrap',
  },
  formControl: {
    // margin: theme.spacing.unit,
    minWidth: 120,
    width: '100%',
    border: 'none'
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
    width: '100%',
  },
});



class SubscriptionPlan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpenAddSUB: false,
      modalIsOpenAddSUBPlans: false,
      modalIsOpenAddSUBView: false,
      modalIsOpenAddSUBEdit: false,
      modalIsOpenDeleteSuccess: false,
      noOfParams: [],
      subData: [],
      siData: [],
      actualData: [],
      searchValue: '',
      loader: true,
      isSwinging: false, // This is using for seinging the '+' sing
      assinedBoxesSI: 0,
      assinedBoxesProjects: 0,
      unAssinedBoxes: 0,
      someState: setTimeout(() => {
        if (this.props.redux.auth.searchBarShow) {
          return 'true'
        } else {
          return 'false'
        }
      }, 500),
      sortingStatus: {
        sortingName: '',
        defaultDown: true
      },
      //states for pagination in table
      paginationTable: {
        currentPage: 0,
        pageNeighbours: 2,
        recordPerPage: 10,
        totalRecords: 0,
        recordFirstID: 0,
        recordLastID: 0,
        buttonArray: []
      }

    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    // this.closeModalDelete = this.closeModalDelete.bind(this);
  }

  openModal() {
    this.setState({
      modalIsOpenAddSUB: false,
      modalIsOpenAddSUBPlans: false
    }, () => {
      this.setState({
        modalIsOpenAddSUB: true,
        modalIsOpenAddSUBPlans: true
      })
    })
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  closeModal() {
    this.setState({ modalIsOpenAddSUB: false });
    this.setState({ modalIsOpenAddSUBPlans: false });
  }

  //   closeModalDelete() {
  //     this.setState({
  //       modalIsOpenDelete: false
  //     });
  //   }


  ActivateSUBModel = (e) => {
    if (this.state.modalIsOpenAddSUB) {
      return <OkasBoxesAddNew activeModal={true} refreshDevices={this.refreshDevices.bind(this)} />
    } if (this.state.modalIsOpenAddSUBPlans) {
      return <SubscriptionsAddPlans activeModal={true} refreshDevices={this.refreshDevices.bind(this)} />
    } else {
      return null
    }
  }

  refreshDevices = (e) => {
    this.setState({
      modalIsOpenAddSUB: false,
      modalIsOpenAddSUBPlans: false,
      modalIsOpenAddSUBView: false,
      modalIsOpenAddSUBEdit: false,
      modalIsOpenDeleteSuccess: false,
    }, () => {
      this.fetchDevices();
    })
  }



  ActivateSUbModelView = (e) => {
    if (this.state.modalIsOpenAddSUBView) {
      return <SubscriptionPlanView activeModal={true} SUbCurrentData={this.state.SUbCurrentData} refreshDevices={this.refreshDevices.bind(this)} />
    } else {
      return null
    }
  }

  ActivateSUbModelEdit = (e) => {
    if (this.state.modalIsOpenAddSUBEdit) {
      return <SubscriptionPlanEdit activeModal={true} SUbCurrentData={this.state.SUbCurrentData} refreshDevices={this.refreshDevices.bind(this)} />
    } else {
      return null
    }
  }

  ///////////////////////////////Swinging '+' Sing start///////////////////////////////////////
  handleMouseEnter = () => {
    this.setState({ isSwinging: true });
  };

  handleMouseLeave = () => {
    this.setState({ isSwinging: false });
  };

  ///////////////////////////////Swinging '+' Sing end///////////////////////////////////////

  componentDidMount() {
    this.fetchSI()
    // this.fetchDevices();
    // this.resetSearchBar()
  }


  fetchDevices = () => {
    this.setState({
      loader: true
    })
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/plan/', {
      method: "GET",
      headers: headers,
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({ forceRefresh: true })
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        let subData = data;

        this.setState({
          subData: subData.data,
          actualData: subData,
          loader: false
        }, () => {

        })
        console.log('Plan Data', this.state.subData)
      })
      .catch((err) => {
        console.log(err)
      })
  }


  restoreData = (data) => {
    this.setState({
      subData: data
    })
  }





  fetchSI = () => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/si_IntegratorApi/', {
      method: "GET",
      headers: headers,
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({ forceRefresh: true })
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        this.setState({
          siData: data,
        }, () => {
          this.fetchDevices()
        })
      })

  }




  numberOfBoxes = (boxState) => {
    let numberOfBoxType = 0;
    this.state.actualData.forEach((e) => {
      if (e.okasBox_status === boxState) {
        numberOfBoxType = numberOfBoxType + 1;
      }
    })
    return numberOfBoxType
  }

  siNameHandler = (data, siId) => {
    let siName = 'Unassigned';
    data.forEach((element) => {
      if (Number(element.si_id) === Number(siId)) {
        siName = element.si_userName
      }
    })
    return siName
  }

  getCurrencySymbol = (currencyCode) => {
    switch (currencyCode.toLowerCase()) {
      case 'dollar':
        return '$';
      case 'rs':
        return '₹';
      // Add more cases for other currencies as needed
      default:
        return currencyCode; // Return the original code if no match is found
    }
  };




  render() {
    const { isSwinging } = this.state;
    return (
      <React.Fragment>
        {this.state.loader ? <Loader /> : null}

        <div style={{ paddingLeft: '-8px', paddingTop: '40px', paddingRight: '6px', height: `${window.innerHeight - 70}px`, }}>
          <div style={{ marginBottom: '20px' }}>
            <span style={{ color: '#888888', fontSize: '30px' }}>SUBSCRIPTION PLANS</span>
            <span style={{ float: 'right' }}>
              {!this.props.redux.auth.searchBarShow ? <div className="row" style={{ margin: '0' }}>
                <a href="/subscriptions">  {/* Path to redirect SubscriptionPlan plan */}

                  <div className="pointer"  >
                    <div className="buttonContent" style={{ backgroundColor: '#2976a7 ', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)' }}>

                      <span style={{ color: '#fff', fontSize: '10px', fontWeight: '600' }}>RETURN TO SUBSCRIPTIONS</span>
                    </div>
                  </div>
                </a>
              </div> : null}
            </span>
          </div>


          <div style={{ display: 'flex', gap: '15px', textAlign: 'center' }}>
            {this.state.subData.map((obElement, index) => (
              <div key={index} className="some-hoverr" style={{ boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px', width: '19%', borderRadius: '20px', cursor: 'pointer', backgroundColor: '#ebf3f8' }} >
                <p style={{ fontSize: '16px', fontWeight: '700', marginTop: '13%' }}>{obElement.plan_name.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}</p>
                <p style={{ fontSize: '25px', fontWeight: '600', color: '#4795ad' }}>{this.getCurrencySymbol(obElement.currency)}{obElement.fees}</p>
                {/* <p>{this.getCurrencySymbol(obElement.currency)}</p> */}
                {obElement.feature.map((feature, featureIndex) => (
                  <p style={{ color: '#94979a', fontWeight: '500' }} key={featureIndex}>✓ {feature.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}</p>
                ))}


              </div>

            ))}


            <div className='addNewBox' >
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: 'white', height: '100%', width: '100%', borderRadius: '20px', justifyContent: 'center', textAlign: 'center' }}>
                <span
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'white',
                    borderRadius: '20px',
                    justifyContent: 'center',
                    textAlign: 'center'
                  }}
                  onClick={() => {
                    if (this.state.modalIsOpenAddSUBPlans) {
                      this.setState({ modalIsOpenAddSUBPlans: false }, () => {
                        this.setState({ modalIsOpenAddSUBPlans: true });
                      });
                    } else {
                      this.setState({ modalIsOpenAddSUBPlans: true });
                    }
                  }}
                >
                  <IconButton
                    sx={{
                      color: '#F08100',
                      fontSize: 40,
                      backgroundColor: 'transparent',
                      '&:hover': { backgroundColor: 'transparent' },
                      '&:focus': {
                        outline: 'none',
                        border: 'none',
                        backgroundColor: 'transparent'
                      },
                      transform: this.state.isSwinging ? 'rotate(90deg)' : 'rotate(0deg)',
                      transition: 'transform 0.3s ease-in-out',
                    }}
                    aria-label="add"
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                  >
                    <AddIcon sx={{ fontSize: 60 }} />
                  </IconButton>
                  <div style={{ color: '#cecece', fontSize: '16px', alignItems: 'center' }}>ADD PLAN</div>
                </span>

              </div>
            </div>
          </div>
          <div className='view_edit_delete' style={{ height: '50px', marginTop: '2%' }}>


            <div style={{ display: 'flex', gap: '15px', textAlign: 'center' }}>
              {this.state.subData.map((obElement, index) => (
                <div key={index} className="some-hoverr" style={{ width: '19%', borderRadius: '20px', cursor: 'pointer', backgroundColor: '#ebf3f8' }} >

                  <p style={{ fontSize: '12px', fontWeight: '700' }}>VIEW | EDIT | DELETE</p>
                  {/* ////////////////////////////////////////////////// View Start /////////////////////////////////////////////////// */}
                  <span
                    // className="fas fa-eye fa-2x pull-right icon-button-si px-2 py-2" 
                    className="fas fa-eye fa-2x pull-right icon-button-si px-2 py-2"
                    onClick={
                      (e) => {
                        if (this.state.modalIsOpenAddSUBView) {
                          this.setState({ modalIsOpenAddSUBView: false }, () => {
                            this.setState({
                              modalIsOpenAddSUBView: true,
                              SUbCurrentData: obElement,

                            })
                          })
                        } else {
                          this.setState({
                            modalIsOpenAddSUBView: true,
                            SUbCurrentData: obElement
                          })
                        }
                      }}
                  >
                    {/* <img src={view} alt="" style={{ width: '16px', height: '16px', marginRight: '15px' }} /> */}
                  </span>
                  {/* ////////////////////////////////////////View End ////////////////////////////////////////////////////// */}


                  {/*//////////////////////////////////////// Edit Start //////////////////////////////////////////////////// */}
                  <span
                    className="fas fa-pen fa-2x pull-right icon-button-si px-2 py-2"
                    onClick={
                      (e) => {
                        if (this.state.modalIsOpenAddSUBEdit) {
                          this.setState({ modalIsOpenAddSUBEdit: false }, () => {
                            this.setState({
                              modalIsOpenAddSUBEdit: true,
                              SUbCurrentData: obElement,
                              siSelected: ''
                            })
                          })
                        } else {
                          this.setState({
                            modalIsOpenAddSUBEdit: true,
                            SUbCurrentData: obElement
                          })
                        }
                      }}
                  >
                    {/* <img src={edit} alt="" style={{ width: '16px', height: '16px', marginLeft: '15px' }} /> */}
                  </span>

                  {/*//////////////////////////////////////////////////// Edit End /////////////////////////////////////////////////////////////////*/}


                  {/*/////////////////////////////////////////////////// Delete Start///////////////////////////////////////////////////////////// */}

                  <span
                    // className="fas fa-eye fa-2x pull-right icon-button-si px-2 py-2" 
                    className="fas fa-trash fa-2x pull-right icon-button-si px-2 py-2"
                    onClick={
                      (e) => {
                        if (this.state.modalIsOpenDeleteSuccess) {
                          this.setState({ modalIsOpenDeleteSuccess: false }, () => {
                            this.setState({
                              modalIsOpenDeleteSuccess: true,
                              // SUbCurrentData: obElement,

                            })
                          })
                        } else {
                          this.setState({
                            modalIsOpenDeleteSuccess: true,
                            // SUbCurrentData: obElement
                          })
                        }
                      }}
                  >
                    {/* <img src={view} alt="" style={{ width: '16px', height: '16px', marginRight: '15px' }} /> */}
                  </span>


                  {/*/////////////////////////////////////////////////// Delete End///////////////////////////////////////////////////////////// */}
                </div>

              ))}
            </div>

          </div>
        </div>
        {this.ActivateSUBModel()}
        {this.ActivateSUbModelView()}
        {this.ActivateSUbModelEdit()}
      </React.Fragment>
    );
  }
}


const mapStateToProps = state => {
  return {
    redux: state,
  };
};



const mapDispatchToProps = dispatch => {
  return {
    searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
    searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),

  };
};


export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionPlan);